import { z } from 'zod';

export const OrganizationUserRoles = ['user', 'admin'] as const;
export const OrganizationUserRole = z.enum(OrganizationUserRoles);
export type OrganizationUserRole = z.infer<typeof OrganizationUserRole>;
